import React, { useEffect, useState, Fragment, useCallback } from 'react';
import * as Api from "../../api";
import { useParams } from "react-router-dom";
import { Card, Col } from 'react-bootstrap';
import DisseminationRequest from "../../components/Ui/DisseminationRequest";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store/reducers/RootReducer";
import { TOrdersByIdState } from "../../store/reducers/ordersById";
import { fetchOrderDetails } from "../../store/action-creators/orders";
import Row from "../../components/Common/Row";
import { copyToClipboard } from '../../utils/Clipboard';
import { faCopy, faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import ButtonWithIcon from '../../components/Buttons/ButtonWithIcon';
import LoadingIndicator from "../../components/Feedback/LoadingIndicator";
import DisseminationRequestPolicy from "../../policies/DisseminationRequestPolicy";
import { selectUser } from "../../store/selectors/UserSelectors";
import NotFoundScreen from "../../components/NotFoundScreen";

interface IRouteParams {
  orderId: string;
}

const OrderDisseminationRequest = () => {
  const params = useParams<IRouteParams>();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const [diss, setDiss] = useState<string | null>(null);
  const [dissError, setDissError] = useState<string | null>(null);
  const [copyStatus, setCopyStatus] = useState<null | 'copied'>(null);

  useEffect(() => {
    dispatch(fetchOrderDetails(params.orderId));
    Api.Order.fetchDisseminationRequest(params.orderId)
      .then(setDiss)
      .catch(() => {
        setDissError('Unable to fetch dissemination request.');
      });
  }, [dispatch, params.orderId]);

  const onCopyToClipboard = useCallback(() => {
    copyToClipboard(diss ?? '');
    setCopyStatus('copied');
  }, [diss]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setCopyStatus(null);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [copyStatus])

  const orderState = useSelector<TRootState, TOrdersByIdState[string] | undefined>(
    store => store.ordersById[params.orderId]
  )

  if (dissError) {
    return <div>{dissError}</div>;
  }

  if (!orderState?.loadedAt || !diss) {
    return <LoadingIndicator />;
  }

  if (orderState.data && !DisseminationRequestPolicy.canAccess(user, orderState.data)) {
    return <NotFoundScreen />;
  }

  return (
    <Fragment>
      <Row>
        {/*<PageTitle title={order.name} />*/}
        <Col>
          <h2 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Dissemination request

            <ButtonWithIcon
              icon={copyStatus === 'copied' ? faCheckCircle : faCopy}
              onClick={onCopyToClipboard}
              variant={copyStatus === 'copied' ? 'success' : 'primary'}
            >
              Copy to clipboard
            </ButtonWithIcon>
          </h2>
        </Col>
      </Row>

      <Card>
        <Card.Body>
          <DisseminationRequest diss={diss} />
        </Card.Body>
      </Card>
    </Fragment>

  )
}

export default OrderDisseminationRequest;
